import { render, staticRenderFns } from "./MNetworkAudits.vue?vue&type=template&id=2d28de5f&lang=pug&"
import script from "./MNetworkAudits.vue?vue&type=script&lang=js&"
export * from "./MNetworkAudits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports